// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Rozmowa',
  working: 'Pracuję nad tym…',
  stopped: 'Zatrzymano. Nic się nie zmieniło.',
  step_stopped: 'Zatrzymano',
  not_sent: 'Nie wysłano',
  failed: {
    text: 'Coś poszło nie tak po mojej stronie, więc nic się nie zmieniło. Spróbuj ponownie za chwilę.',
    retry: 'Spróbuj ponownie',
  },
  question: {
    type_answer: 'Lub wpisz odpowiedź poniżej.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo jest teraz niedostępny.',
      assistant: 'Asystent jest teraz niedostępny.',
    },
    text: 'Nic się nie zmieniło, a reszta panelu działa normalnie. Spróbuj ponownie za kilka minut.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Dzisiaj',
  when: {
    today: 'Dzisiaj, {{time}}',
    yesterday: 'Wczoraj, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Nowy czat dla {{restaurant}}. Czaty lokalu {{previous}} znajdziesz w sekcji Czaty, gdy do niego wrócisz.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Czat użytkownika {{name}} (FoodAmigos)',
      owner: 'Czat użytkownika {{name}} (właściciel)',
      staff: 'Czat użytkownika {{name}} (personel)',
      partner: 'Czat użytkownika {{name}} (partner)',
      other: 'Czat użytkownika {{name}}',
      unnamed: 'Czat innej osoby',
    },
    text: 'Czat użytkownika {{name}}. Możesz go czytać, ale nie możesz odpowiadać ani zatwierdzać jego kart.',
    text_unnamed: 'Czat innej osoby. Możesz go czytać, ale nie możesz odpowiadać ani zatwierdzać kart.',
    new_chat: 'Nowy czat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Ta rozmowa została zakończona. Rozpocznij nową, aby kontynuować.',
    new_chat: 'Nowy czat',
    moved_line: 'Nowy czat, bo poprzedni został zakończony',
  },
  composer: {
    label: 'Wiadomość',
    placeholder: 'Zadaj pytanie lub opisz zmianę',
    placeholder_answer: 'Wpisz swoją odpowiedź',
    hint: 'Enter, aby wysłać · Shift+Enter, aby przejść do nowej linii',
  },
  table: {
    show_all: 'Pokaż wszystkie wiersze ({{count}})',
    show_fewer: 'Pokaż mniej',
  },
  steps: {
    areas: 'Sprawdzam, w czym mogę tu pomóc',
    area_describe: 'Przeglądam obszar: {{area}}',
    read: 'Odczytuję Twoje dane',
    propose: 'Przygotowuję zmianę',
    change_set_get: 'Sprawdzam zmianę',
    gap_record: 'Notuję to dla naszego zespołu',
    research: 'Sprawdzam, jak to działa',
    screen_find: 'Szukam odpowiedniej strony',
    file_read: 'Odczytuję Twój plik',
    shop_check: 'Sprawdzam Twój sklep',
    area_describe_other: 'Przeglądam ten obszar',
    other: 'Sprawdzam coś',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Nie udało się wczytać menu',
      hours: 'Nie udało się wczytać godzin otwarcia',
      order_settings: 'Nie udało się wczytać ustawień zamówień',
      my_info: 'Nie udało się wczytać Twoich danych',
      marketing: 'Nie udało się wczytać Twoich działań marketingowych',
      gift_cards: 'Nie udało się wczytać kart podarunkowych',
      reports: 'Nie udało się wczytać Twoich wyników',
      other: 'Nie udało się wczytać Twoich danych',
    },
    propose: {
      menu: 'Nie udało się przygotować zmiany w menu',
      hours: 'Nie udało się przygotować zmiany godzin otwarcia',
      order_settings: 'Nie udało się przygotować zmiany ustawień zamówień',
      my_info: 'Nie udało się przygotować zmiany w Twoich danych',
      marketing: 'Nie udało się przygotować zmiany w marketingu',
      gift_cards: 'Nie udało się przygotować zmiany w kartach podarunkowych',
      other: 'Nie udało się przygotować zmiany',
    },
    change_set_get: { other: 'Nie udało się sprawdzić zmiany' },
    research: { other: 'Nie udało się sprawdzić, jak to działa' },
    screen_find: { other: 'Nie udało się znaleźć strony' },
    file_read: { other: 'Nie udało się wczytać Twojego pliku' },
    shop_check: { other: 'Nie udało się otworzyć Twojego sklepu' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'menu',
    hours: 'godziny otwarcia',
    order_settings: 'ustawienia zamówień',
    my_info: 'dane Twojej restauracji',
    marketing: 'marketing',
    reports: 'raporty',
  },
};
